module.exports = __webpack_public_path__ + "static/media/Fun-vs.-Quality-of-Day.e5fe1c44.png";